export var isInIframe = function isInIframe() {
  try {
    return window !== window.top;
  } catch (_unused) {
    // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
    return true;
  }
};
export var isWithinPreviewPanel = function isWithinPreviewPanel() {
  try {
    var params = new URLSearchParams(window.location.search);
    return params.has('previewPanels') || params.get('embeddedConfluenceSource') === 'confluence-page-preview-panel';
  } catch (_unused2) {
    return false;
  }
};
export var isModalWithinPreviewPanelIFrame = function isModalWithinPreviewPanelIFrame() {
  return isInIframe() && isWithinPreviewPanel();
};

// Signals parent product to open embed modal via postMessage when in iframe context
export var openEmbedModalInParent = function openEmbedModalInParent(modalProps) {
  if (!isInIframe()) {
    return;
  }
  window.parent.postMessage({
    type: 'OPEN_EMBED_MODAL',
    payload: {
      modal: {
        url: (modalProps === null || modalProps === void 0 ? void 0 : modalProps.url) || ''
      }
    }
  }, '*');
};